// errors
export const ERROR_TECNICO = "error-1";
export const INDIVIDUO_NEGATIVO = "error-2";
export const CLIENTE_EXISTENTE = "error-2";
export const RECHAZADO_OTROS = "error-3";
export const ERROR_NOSIS = "error-4";
export const RECHAZADO = "error-5";
export const INDIVIDUO_NEGATIVO_EMPRENDEDOR = "error-6";
export const GRACIAS = "gracias";
